module.exports = __webpack_public_path__ + "img/img_chargingstation.c2cec753.png";